import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { useAuth } from './AuthContext';
import { fetchMySubscription } from '../api/services';

const SubContext = createContext(null);
// Legacy plans keep access: standard -> basic, premium -> live
export const PLAN_TIER = { basic: 'basic', standard: 'basic', live: 'live', premium: 'live' };
export const PLAN_NAMES = { free: 'Free', basic: 'Basic', standard: 'Basic', live: 'Live Events', premium: 'Live Events' };

export const SubscriptionProvider = ({ children }) => {
  const { user } = useAuth();
  const [sub, setSub] = useState({ plan: 'free', status: 'inactive', period_end: null });
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!user) { setSub({ plan: 'free', status: 'inactive' }); return; }
    setLoading(true);
    try {
      const data = await fetchMySubscription();
      setSub(data);
    } catch {
      setSub({ plan: 'free', status: 'inactive' });
    } finally { setLoading(false); }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const notExpired = !sub?.period_end || new Date(sub.period_end) > new Date();
  const tier = (sub?.status === 'active' || (sub?.status === 'canceled' && sub?.period_end && notExpired)) ? PLAN_TIER[sub?.plan] : null;
  const isSubscribed = !!tier;
  const isLive = tier === 'live';

  return (
    <SubContext.Provider value={{ sub, loading, refresh, isSubscribed, isLive, tier }}>
      {children}
    </SubContext.Provider>
  );
};

export const useSubscription = () => useContext(SubContext);
